<template>
  <div class="competency-manager-view">
    <CompetencyManager />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CompetencyManager from "../components/CompetencyManager.vue";

export default defineComponent({
  name: "CompetencyManagerView",
  components: {
    CompetencyManager,
  },
});
</script>

<style scoped></style>
